import { Link } from 'react-router-dom';
import { Briefcase, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="bg-gradient-to-br from-orange-500 to-red-600 p-2 rounded-lg">
                <Briefcase className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold text-white">Kari Future Now Creations™</span>
            </div>
            <p className="text-sm text-gray-400">
              Premium AI-powered digital products + the only AI Auto-Poster with 8 superpowers. Built for creators who refuse to stay broke.
            </p>
            <div className="text-xs text-orange-400/80 italic">
              ⚡ Every post, every product, every output — Made with Kari Future Now Creations™
            </div>
            <div className="flex space-x-3">
              <a href="#" aria-label="Facebook" className="w-9 h-9 flex items-center justify-center rounded-lg bg-gray-800 hover:bg-orange-600 transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" aria-label="Twitter" className="w-9 h-9 flex items-center justify-center rounded-lg bg-gray-800 hover:bg-orange-600 transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" aria-label="Instagram" className="w-9 h-9 flex items-center justify-center rounded-lg bg-gray-800 hover:bg-orange-600 transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" aria-label="LinkedIn" className="w-9 h-9 flex items-center justify-center rounded-lg bg-gray-800 hover:bg-orange-600 transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm hover:text-orange-500 transition-colors">Home</Link></li>
              <li><Link to="/marketplace" className="text-sm hover:text-orange-500 transition-colors">Marketplace</Link></li>
              <li><Link to="/ai-auto-poster" className="text-sm hover:text-orange-500 transition-colors">AI Auto-Poster</Link></li>
              <li><Link to="/ai-lab" className="text-sm hover:text-orange-500 transition-colors">AI Lab</Link></li>
              <li><a href="#services" className="text-sm hover:text-orange-500 transition-colors">Services</a></li>
              <li><a href="#about" className="text-sm hover:text-orange-500 transition-colors">About</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-sm hover:text-orange-500 transition-colors">Content Creation</a></li>
              <li><a href="#" className="text-sm hover:text-orange-500 transition-colors">App Development</a></li>
              <li><a href="#" className="text-sm hover:text-orange-500 transition-colors">Advertising</a></li>
              <li><a href="#" className="text-sm hover:text-orange-500 transition-colors">Consulting</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">1-740-530-7548</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">contact@karifuturenow.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">Los Angeles, CA</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} Kari Future Now Creations™. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Privacy Policy</a>
              <a href="#" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Terms of Service</a>
              <a href="#" className="text-sm text-gray-400 hover:text-orange-500 transition-colors">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
